exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#login[data-v-b29a7f62]{margin-top:32px;text-align:center}#login .logo[data-v-b29a7f62]{width:64px;height:64px}", ""]);

// exports
